const article = () => import('@/view/classroom/article');
const articleDetail = () => import('@/view/classroom/article-detail');
const articleCategory = () => import('@/view/classroom/article-category');
const poster = () => import('@/view/classroom/poster');


export default [{
  path: '/article',
  name: 'article',
  component: article
}, {
  path: '/article-detail',
  name: 'articleDetail',
  component: articleDetail
}, {
  path: '/article-category',
  name: 'articleCategory',
  component: articleCategory
},{
  path: '/poster',
  name: 'poster',
  component: poster
}];